import React from "react";
import { Helmet } from "react-helmet";
import json from "../../../metaData.json";
import packageJson from "../../../../package.json";
import { getBrandingConfig } from "authentication/runtimeConfig";

interface MetaDecoratorProps {
  title?: string;
}

const MetaDecorator: React.FC<MetaDecoratorProps> = (props) => {
  const branding = getBrandingConfig();
  const { title = branding.appName } = props;
  const { branchName, commitID } = json;
  const { icons } = branding;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={branding.metaDescription} />
      <meta name="version" content={packageJson.version} />
      <meta name="branch-name" content={branchName} />
      <meta name="commit-id" content={commitID} />
      {icons && <link rel="icon" type="image/x-icon" href={icons.favicon} />}
      {icons && <link rel="icon" type="image/png" sizes="16x16" href={icons.favicon16} />}
      {icons && <link rel="icon" type="image/png" sizes="32x32" href={icons.favicon32} />}
      {icons && <link rel="apple-touch-icon" sizes="180x180" href={icons.appleTouchIcon} />}
    </Helmet>
  );
};

export default MetaDecorator;
